'use strict';

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require('../css/supermenu.css');

var rendy = require('rendy/legacy');

var createElement = require('@cloudcmd/create-element');

module.exports = Supermenu;

function Supermenu(element, options, menuData) {
  if (!(this instanceof Supermenu)) return new Supermenu(element, options, menuData);
  var ElementFuncs = new ElementFuncsProto();
  var Options = {};
  var ElementMenu;
  var Element;
  var ElementHeight;
  var ElementWidth;
  var ElementEvent;
  var MenuFuncs = {};
  var TEMPLATE = {
    MAIN: '<ul data-name="js-menu" class="menu menu-hidden">' + '{{ items }}' + '</ul>',
    ITEM: '<li data-name="js-menu-item" class="menu-item{{ className }}"{{ attribute }}>' + '<label data-menu-path="{{ path }}">{{ name }}</label>' + '{{ subitems }}' + '</li>'
  };

  if (menuData) {
    Element = ElementEvent = element;
    Options = options;
  } else if (options) {
    Element = ElementEvent = element;
    menuData = options;
  } else {
    Element = document.body;
    ElementEvent = window;
    menuData = element;
  }

  function init() {
    var isObj = _typeof(menuData) === 'object';

    if (!isObj) {
      var name = menuData;
      menuData = {};
      menuData[name] = null;
    }

    ElementMenu = createMenu(menuData);
    ElementEvent.addEventListener('click', onClick);
    ElementEvent.addEventListener('contextmenu', onContextMenu);
  }

  function createMenu(menuData) {
    var menu;
    var items = '';

    var buildItems = function buildItems(menuData, path) {
      var DATA_MENU = 'data-menu="js-submenu"';
      var Data_KEY = 'data-key=';
      var items = '';
      if (path) path += '.';else path = '';
      Object.keys(menuData).forEach(function (name) {
        var nameIcon;
        var key = '';
        var subitems = '';
        var className = '';
        var attribute = '';
        var pathName = path + name;
        var data = menuData[name];
        var isObj = _typeof(data) === 'object';

        if (!isObj) {
          MenuFuncs[pathName] = data;
        } else {
          subitems = rendy(TEMPLATE.MAIN, {
            items: buildItems(data, pathName)
          });
          className = ' menu-submenu';
          attribute = ' ' + DATA_MENU;
        }

        if (Options.icon) {
          nameIcon = name.replace(/\(|\)/g, '').replace(/\s/g, '-').toLowerCase();
          className += ' icon icon-' + nameIcon;
        }

        if (Options.keys) {
          key = Options.keys[name];
          if (key) attribute = ' ' + Data_KEY + key;
        }

        items += rendy(TEMPLATE.ITEM, {
          name: name,
          subitems: subitems,
          className: className,
          attribute: attribute,
          path: pathName
        });
      });
      return items;
    };

    items = buildItems(menuData);
    menu = createElement('ul', {
      dataName: 'js-menu',
      className: 'menu menu-hidden',
      innerHTML: items,
      parent: Element,
      uniq: false
    });
    return menu;
  }

  this.show = showMenuElement;
  this.hide = hideMenuElement;

  function checkElement(target, position) {
    var element = ElementFuncs.getItem(target);
    var isName = ElementFuncs.isName(element);
    var isItem = ElementFuncs.isItem(element);
    var isSub = ElementFuncs.isSubMenu(element);

    if (!isName || !isItem) {
      element = document.elementFromPoint(position.x, position.y);
      isSub = ElementFuncs.isSubMenu(element);
      isName = ElementFuncs.isName(element);
      isItem = ElementFuncs.isItem(element);
    }

    return {
      name: isName,
      item: isItem,
      sub: isSub
    };
  }

  function onClick(event, checkResult) {
    event.stopPropagation();
    var afterClick = Options.afterClick;
    var beforeClick = Options.beforeClick;
    var name = Options.name;
    var element = event.target;
    var is = checkResult || checkElement(element, {
      x: event.clientX,
      y: event.clientY
    });
    var notClick = exec(beforeClick, name);
    if (is.sub) return event.preventDefault();
    hideMenuElement();

    if (!notClick && (is.name || is.item)) {
      var itemData = getMenuItemData(element);
      exec(itemData);
      exec(afterClick);
    }
  }

  function onContextMenu(event) {
    event.preventDefault();
    var element = event.target;
    var x = event.clientX;
    var y = event.clientY;
    var is = checkElement(element, {
      x: x,
      y: y
    });
    if (is.name || is.item || is.sub) return onClick(event, is);
    hideMenuElement();
    showMenuElement(x, y);
  }

  function setMenuPosition(x, y) {
    var isNumberX = typeof x === 'number';
    var isNumberY = typeof y === 'number';
    var heightMenu = getMenuHeight();
    var widthMenu = getMenuWidth();
    var heightInner = window.innerHeight;
    var widthInner = window.innerWidth;

    if (widthInner < widthMenu + x) {
      x -= widthMenu;
      if (x < 0) x = 0;
    }

    if (heightInner < heightMenu + y) {
      y -= heightMenu;
      if (y < 0) y = 0;
    }

    if (isNumberX) ElementMenu.style.left = x + 'px';
    if (isNumberY) ElementMenu.style.top = y - 14 + 'px';
  }

  function showMenuElement(x, y) {
    var _Options = Options,
        name = _Options.name,
        beforeShow = _Options.beforeShow;
    var params = {
      x: x,
      y: y,
      name: name
    };
    var notShow = exec(beforeShow, params);

    if (!notShow) {
      ElementMenu.classList.remove('menu-hidden');
      setMenuPosition(params.x, params.y);
    }
  }

  function hideMenuElement() {
    var notHide = exec(Options.beforeClose);
    if (!notHide) ElementMenu.classList.add('menu-hidden');
  }

  function getMenuItemData(element) {
    var path;
    element = ElementFuncs.getName(element);
    if (element) path = element.getAttribute('data-menu-path');
    return MenuFuncs[path];
  }

  function getMenuHeight() {
    if (!ElementHeight) {
      var styleComputed = getComputedStyle(ElementMenu);
      var height = styleComputed.height;
      ElementHeight = parseInt(height, 10);
    }

    return ElementHeight;
  }

  function getMenuWidth() {
    var styleComputed, width;

    if (!ElementWidth) {
      styleComputed = getComputedStyle(ElementMenu);
      width = styleComputed.width;
      ElementWidth = parseInt(width, 10);
    }

    return ElementWidth;
  }

  init();
}

function ElementFuncsProto() {
  this.getItem = getItem;
  this.getName = getName;
  this.isName = isName;
  this.isItem = isItem;
  this.isMenu = isMenu;
  this.isSubMenu = isSubMenu;

  function getItem(element) {
    var isNameElement;

    if (element) {
      isNameElement = isName(element);
      if (isNameElement) element = element.parentElement;
    }

    return element;
  }

  function getName(element) {
    if (element) {
      var is = isName(element);
      if (!is) element = element.querySelector('[data-menu-path]');
    }

    return element;
  }

  function isName(element) {
    if (!element) return;
    return element.hasAttribute('data-menu-path');
  }

  function isItem(element) {
    return checkElementsName(element, 'js-menu-item');
  }

  function isMenu(element) {
    return checkElementsName(element, 'js-menu');
  }

  function checkElementsName(element, nameElement, attribute) {
    var itIs;
    if (!attribute) attribute = 'data-name';

    if (element) {
      var name = element.getAttribute(attribute);
      if (name === nameElement) itIs = true;
    }

    return itIs;
  }

  function isSubMenu(element) {
    var attribute = 'data-menu';
    var value = 'js-submenu';
    var item = getItem(element);
    var itIs = checkElementsName(item, value, attribute);
    return itIs;
  }
}

function exec(callback) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (typeof callback === 'function') return callback.apply(void 0, args);
}